import { RotatingLines } from "react-loader-spinner";
import { useAtomValue } from "jotai";
import { themeAtom } from "@/store/atoms";

export default function LoadingSpinner() {
  const themeAtomValue = useAtomValue(themeAtom);

  return (
    <div className="flex items-center justify-center p-4">
      <RotatingLines
        width={"50"}
        strokeWidth="5"
        strokeColor={themeAtomValue === "dark" ? "white" : "black"}
        animationDuration="0.75"
        ariaLabel="rotating-lines-loading"
      />
    </div>
  );
}
